import { Object, Static } from '@sinclair/typebox';

import { TUnionEnum, UnionEnum } from '../../../utils/unionEnum';

export const TravelPassError = UnionEnum([
  'invalid-request',
  'missing-products-query-params', // 400
  'missing-travelers-query-params', // 400
  'offer-not-found', //400
  'no-passenger-to-book', //400
  'dates-not-within-product-range', // 400
  'invalid-dates', // 400
  'missing-product-code', //400
  'flight-is-full', // 400
  'invalid-user-session', // 401
  'generic-permission-denied', // 403
  'product-not-found', // 403
  'offer-id-required', // 403
  'not-enough-punches-available', // 403
  'invalid-bound', // 400
  'confirm-pnr-failed', //500
  'ssr-sktp-not-found', //500
  'ssr-sktp-is-no', //500
  'unknown', // 500
  'duplicate-booking', // 500
  'invalid-ffp-number', //400
  'journey-not-found-for-requested-itinerary', //400
  'reservation-not-found', //400
  'rebooking-failed', //500
  'invalid-traveller', // 403
  'invalid-email-recipient', // 400
  'invalid-pnr', // 400
  'invalid-date-of-birth',
  'departure-too-close', // 400
  'invalid-invoice-details', // 400
]);
export type TravelPassError = Static<typeof TravelPassError>;

export const TravelPassApiAnyError = () =>
  Object({
    bookingErrorType: TravelPassError,
  });

export const TravelPassApiError = (error: TUnionEnum<TravelPassError[]>) =>
  Object({
    bookingErrorType: error,
  });
